import React from 'react';
import { Icons } from '@nxsys/types/icons';
import type { RequiredAlertsCounts } from '@nxsys/store/slices/dashboard/types';

const CRITICAL_ICON_COLOR = '#CC2D30';
const DEFAULT_ICON_COLOR = '#09090B';

export const getRequiredAlertsOrder = (
  isIreland: boolean,
): (keyof RequiredAlertsCounts)[] => [
  'onHold',
  'withRecurringPayments',
  'withRecurringDeductions',
  isIreland ? 'missingPPSNumber' : 'missingNINumber',
  ...(isIreland
    ? (['missingRPNActionNeeded', 'missingRPNAwaiting'] as const)
    : []),
  'missingAddress',
  'missingEmail',
];

export const ALERT_LABEL_KEYS: Record<keyof RequiredAlertsCounts, string> = {
  missingNINumber: 'common.missingNINumber',
  missingPPSNumber: 'common.missingPPSNumber',
  missingAddress: 'common.missingAddress',
  missingEmail: 'common.missingEmail',
  onHold: 'common.onHold',
  withRecurringPayments: 'common.withRecurringPayments',
  withRecurringDeductions: 'common.withRecurringDeductions',
  missingRPNActionNeeded: 'common.missingRPNActionNeeded',
  missingRPNAwaiting: 'common.missingRPNAwaiting',
};

export const CRITICAL_ALERT_KEYS = new Set<keyof RequiredAlertsCounts>([
  'missingNINumber',
  'missingPPSNumber',
  'missingAddress',
  'missingEmail',
  'missingRPNActionNeeded',
]);

export const getIconForAlert = (
  id: string,
  isCritical: boolean,
): React.ReactNode => {
  const color = isCritical ? CRITICAL_ICON_COLOR : DEFAULT_ICON_COLOR;
  const size = { width: 28, height: 28 };
  switch (id) {
    case 'missingNINumber':
    case 'missingPPSNumber':
      return <Icons.IconFileListTimes {...size} color={color} />;
    case 'missingAddress':
      return <Icons.IconLocationPinExclamation {...size} color={color} />;
    case 'missingEmail':
      return <Icons.IconEnvelopeTimes {...size} color={color} />;
    case 'onHold':
      return <Icons.IconOnHold {...size} color={color} />;
    case 'withRecurringPayments':
      return <Icons.IconRecurring {...size} color={color} />;
    case 'withRecurringDeductions':
      return <Icons.IconDeductions {...size} color={color} />;
    case 'missingRPNActionNeeded':
    case 'missingRPNAwaiting':
      return <Icons.IconFileListTimes {...size} color={color} />;
    default:
      return null;
  }
};
